export const AdminRouteMap = {
  ANY: '*',
  ADDUSER: 'add-user',
  BLANK: '/',
  CHALLENGES: 'challenges/*',
  EXERCISES: 'exercises/*',
  HOSPITALS: 'hospitals',
  ARCHIVE_HOSPITALS: 'archive-hospitals',
  LIBRARY: 'library',
  MESSAGE: 'messages',
  ORGANIZATIONS: 'organizations',
  ARCHIVE_ORGANIZATIONS: 'archive-organizations',
  ARCHIVE_ORGANIZATIONS_DETAIL: ':orgId/detail',
  PATIENTS: 'patients/*',
  PROFILE: ':userId/profile',
  RESOURCES: 'resources/*',
  USERS: 'users/*',
};

export const ChallengeRouteMap = {
  ANY: '*',
  ADDFORM: 'add-challenge',
  DETAIL: ':challengeId/detail',
  EDIT: ':challengeId/edit',
  REPORT: ':challengeId/report',
  TABLEVIEW: 'challenge-table',
  REST: 'challenge/*',
};

export const ExerciseRouteMap = {
  ANY: '*',
  ADDFORM: 'add-exercise',
  DETAIL: ':exerciseId/detail',
  EDIT: ':exerciseId/edit',
  REPORT: ':exerciseContentId/report',
  TABLEVIEW: 'exercise-table',
  REST: 'exercises/*',
};

export const ResourceRouteMap = {
  ANY: '*',
  ADDFORM: 'add-resource',
  DETAIL: ':resourceId/detail',
  EDIT: ':resourceId/edit',
  TABLEVIEW: 'resource-table',
  REST: 'resources/*',
};

export const InitialRouteMap = {
  ANY: '*',
  CHANGEPASSWORD: '/change-password',
  FORGOTPASSWORD: '/forgot-password',
  LOGIN: '/login',
  RESETPASSWORD: '/reset-password',
  REST: '/admin/*',
};

export const PatientRouteMap = {
  ANY: '*',
  ARCHIVED: 'archived-patients',
  DETAIL: ':patientId/detail',
  ADD: 'add-patients',
  EDIT: ':patientId/edit',
  REPORT: ':patientGoalId/goal-report',
  TABLE: 'patients-table',
  REST: 'patients/',
  SEARCH: 'patient-search',
  ENCOUNTER_REPORT: 'patient/report',
};

export const UsersRouteMap = {
  ANY: '*',
  DETAIL: ':userId/detail',
  EDIT: ':userId/edit',
  TABLE: 'users-table',
  REST: 'users/',
};
